import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/evse.png'


const _hoisted_1 = { class: "evse evse-details details" }
const _hoisted_2 = { class: "detail-top" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-header__block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "64"
  })
], -1)
const _hoisted_6 = { class: "info-tags" }
const _hoisted_7 = { class: "info-tags" }
const _hoisted_8 = { class: "button-group" }
const _hoisted_9 = { class: "app-wrapper" }

import EssDeviceInfo from './EssDeviceInfo.vue'
import { computed } from 'vue'
import { ElMessageBox as MB, ElMessage, ElMessageBox } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import DetailHeader from '@/components/DetailHeader.vue'
import EvseStatus from '@/components/EvseStatus.vue'
import DetailInfoTag from '@/components/DetailInfoTag.vue'
import Cards from '@/views/Users/Cards.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'
import { dateFormat, throttleBtn } from '@/common/tools'
import EvseOperationType from '@/components/EvseOperationType.vue'
import EvseInfo from './components/EvseInfo.vue'
import {
  getEvseInfo,
  banEvse,
  evseReboot,
  evseReset,
  evseClearCache,
  evseClearProfile,
  evseOperationCtrl,
  sendPriceingByEvse,
  sendQrcode,
} from '@/api/evses'
import EvseDrawer from './components/EvseDrawer.vue'
import EvseOverview from './components/EvseOverview.vue'
import EvseConnectors from './components/EvseConnectors.vue'
import EvseConfig from './components/EvseConfig.vue'
import EvseRunLog from './components/EvseRunLog.vue'
import EvseProflie from './components/EvseProflie.vue'
import EvseTracelessOta from './components/EvseTracelessOta.vue'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { checkMenuShow } from '@/store/tool'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent, ref } from 'vue'
import LinkStation from '@/components/Links/LinkStation.vue'
import EnergyFlowCanvas from '@/components/EnergyFlowCanvas.vue'
const __default__ = defineComponent({
  name: 'EvseDetails',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')
const showMoreQuery = ref(false)

const showOTADialog = ref(false)

const showDialog = ref(false)
const showDialogEvse = ref({})
const editEvse = () => {
  showDialogEvse.value = evse.value
  showDialog.value = true
}

const route = useRoute()
const router = useRouter()
const evseDetailLock = ref(false)

const evseid = computed(function () {
  return route.params.id
})

const evse = ref<Record<string, any>>({
  id: evseid,
})
const currTab = ref('overview')

const handleCommand = async (command: any) => {
  console.log('Selected command:', command)

  if (command === 'ota') {
    showOTADialog.value = true
    return
  }

  try {
    var cmsdesc = ''
    switch (command) {
      case 'reboot':
        cmsdesc = t('Evses.evseReboot')
        break
      case 'clearCache':
        cmsdesc = t('Evses.evseClearCache')
        break
      case 'clearProfile':
        cmsdesc = t('Evses.evseClearProflie')
        break
      case 'reset':
        cmsdesc = t('Evses.evseReset')
        break
      case 'non-operational':
        cmsdesc = t('Evses.nonOperational')
        break
      case 'operational':
        cmsdesc = t('Evses.operational')
        break
      case 'sendPricing':
        cmsdesc = t('Evses.sendPricing')
        break
      case 'sendQrcode':
        cmsdesc = t('Evses.sendQrcode')
        break
      default:
        break
    }

    await ElMessageBox.confirm(t('Base.confirmOp') + cmsdesc + ' ?', {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })

    const ctrlreq = {
      evseID: evse.value.id,
    }
    switch (command) {
      case 'reboot':
        await evseReboot(ctrlreq)
        break
      case 'clearCache':
        await evseClearCache(ctrlreq)
        break
      case 'clearProfile':
        await evseClearProfile(ctrlreq)
        break
      case 'reset':
        await evseReset(ctrlreq)
        break
      case 'non-operational':
        await evseOperationCtrl({ id: evse.value.id, isOperation: false })
        break
      case 'operational':
        await evseOperationCtrl({ id: evse.value.id, isOperation: true })
        break
      case 'sendPricing':
        await sendPriceingByEvse(evse.value.id)
        break
      case 'sendQrcode':
        await sendQrcode({ evseId: evse.value.id })
        break
    }
    ElMessage.success(t(`Base.opSuccess`))
  } catch (error) {
    console.error('command:', error)
  }
}

const loadData = async function () {
  getEvseInfo({
    id: evseid.value,
    noNeedOverview: true,
  })
    .then((res: any) => {
      console.log('🚀 ~ .then ~ res========== evse:', res)
      evse.value = res.evse
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

const updateEnable = () => {
  banEvse(evse.value.id, evse.value.enable)
}

const initData = async () => {
  await loadData()
}

initData()

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailHeader, {
        item: { name: `编号: ${evse.value.sn} ID: ${evse.value.id}` }
      }, null, 8, ["item"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(EvseStatus, {
                state: evse.value.state
              }, null, 8, ["state"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(LinkStation, {
              id: evse.value.stationID,
              name: evse.value.stationName
            }, null, 8, ["id", "name"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_tooltip, {
            content: evse.value.enable ? _ctx.$t('Base.enable') : _ctx.$t('Base.disable'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              (evse.value.banned)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    class: "enable-btn",
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('Evses.nonOperational')), 1)
                    ]),
                    _: 1
                  }))
                : (_unref(checkMenuShow)('evseBan'))
                  ? (_openBlock(), _createBlock(_component_el_switch, {
                      key: 1,
                      class: "enable-btn",
                      disabled: !_ctx.$hasPermission('post'),
                      modelValue: evse.value.banned,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((evse.value.banned) = $event)),
                      "active-value": false,
                      "inactive-value": true,
                      onChange: updateEnable
                    }, null, 8, ["disabled", "modelValue"]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["content"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tooltip, {
            content: _ctx.$t('Base.edit'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                disabled: !_ctx.$hasPermission('post'),
                type: "primary",
                icon: _unref(Edit),
                plain: "",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editEvse()))
              }, null, 8, ["disabled", "icon"])
            ]),
            _: 1
          }, 8, ["content"])), [
            [_directive_role, 'evseUpsert']
          ]),
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Evses.evseOp'),
            placement: "top",
            loading: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "sendQrcode" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.sendQrcode')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseSendQrcode']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "sendPricing" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.sendPricing')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseSendPricing']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "reboot" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.evseReboot')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseReboot']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "ota" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.evseTricelessOTA')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseTricelessOTA']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                        command: "clearCache",
                        divided: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.evseClearCache')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseClearCache']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "clearProfile" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.evseClearProflie')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseClearProfile']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                        command: "reset",
                        divided: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.evseReset')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseReset']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                        command: "non-operational",
                        divided: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.nonOperational')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseNonOperation']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "operational" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Evses.operational')), 1)
                        ]),
                        _: 1
                      })), [
                        [_directive_role, 'evseNonOperation']
                      ])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "icon-button",
                    plain: "",
                    size: "small",
                    type: "primary",
                    icon: _unref(ArrowDown)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
              class: "detail-tabs",
              modelValue: currTab.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currTab).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_tab_pane, {
                    label: _ctx.$t('Base.overview'),
                    name: "overview",
                    lazy: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(EvseInfo, { evse: evse.value }, null, 8, ["evse"]),
                      _createVNode(EvseOverview, {
                        evseId: evse.value.id,
                        style: {"padding-left":"0px","padding-right":"0px"}
                      }, null, 8, ["evseId"]),
                      _createVNode(EvseConnectors, {
                        evseid: evse.value.id,
                        connectors: evse.value.connectors,
                        style: {"padding-left":"0px","padding-right":"0px"}
                      }, null, 8, ["evseid", "connectors"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: _ctx.$t('Evses.localAuthorizationList'),
                    name: "card",
                    lazy: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Cards, {
                        hideFilter: true,
                        operatorID: evse.value.operatorID,
                        evseID: evse.value.id
                      }, null, 8, ["operatorID", "evseID"])
                    ]),
                    _: 1
                  }, 8, ["label"])), [
                    [_directive_role, 'driverCards']
                  ]),
                  (_unref(checkMenuShow)('evseConfigSet') || _unref(checkMenuShow)('evseConfigGet'))
                    ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                        key: 0,
                        label: _ctx.$t('Base.config'),
                        name: "config",
                        lazy: true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(EvseConfig, {
                            evse: evse.value,
                            style: {"padding-left":"0px","padding-right":"0px"}
                          }, null, 8, ["evse"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: _ctx.$t('Base.runlog'),
                    name: "runlog",
                    lazy: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(EvseRunLog, {
                        evse: evse.value,
                        style: {"padding-left":"0px","padding-right":"0px"}
                      }, null, 8, ["evse"])
                    ]),
                    _: 1
                  }, 8, ["label"])), [
                    [_directive_role, 'evseRunLogList']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: _ctx.$t('Evses.profile'),
                    name: "profile",
                    lazy: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(EvseProflie, {
                        evseid: evse.value.id,
                        connectorNum: evse.value.connectors.length,
                        style: {"padding-left":"0px","padding-right":"0px"}
                      }, null, 8, ["evseid", "connectorNum"])
                    ]),
                    _: 1
                  }, 8, ["label"])), [
                    [_directive_role, 'evseProfileList']
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])), [
              [
                _directive_loading,
                evseDetailLock.value,
                void 0,
                { lock: true }
              ]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(EvseDrawer, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      isEdit: true,
      evseInfo: showDialogEvse.value,
      onSubmitted: loadData
    }, null, 8, ["modelValue", "evseInfo"]),
    _createVNode(EvseTracelessOta, {
      modelValue: showOTADialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showOTADialog).value = $event)),
      evseid: evse.value.id
    }, null, 8, ["modelValue", "evseid"])
  ]))
}
}

})